export const HOME = {
  emergentLink: "home-emergent-link",
  heroBookDemo: "hero-book-demo-btn",
  heroRequestQuote: "hero-request-quote-btn",
  heroDownloadBrochure: "hero-download-brochure-btn",
  heroWatchTour: "hero-watch-tour-btn",
};

export const NAV = {
  container: "site-navbar",
  logo: "nav-logo",
  bookDemo: "nav-book-demo-btn",
  mobileToggle: "nav-mobile-toggle",
};

export const CONTACT = {
  form: "contact-form",
  company: "contact-company-input",
  name: "contact-name-input",
  email: "contact-email-input",
  phone: "contact-phone-input",
  industry: "contact-industry-select",
  employees: "contact-employees-select",
  currentSoftware: "contact-current-software-input",
  customization: "contact-customization-select",
  message: "contact-message-textarea",
  submit: "contact-submit-btn",
  bookDemo: "contact-book-demo-btn",
  requestQuote: "contact-request-quote-btn",
  downloadBrochure: "contact-download-brochure-btn",
};
